import {Component, Input, OnInit} from '@angular/core';
import {Table} from '@tj/tj-dmp-lib-api';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    selector: 'dmp-row-editor',
    templateUrl: './row-editor.component.html',
    styleUrls: ['./row-editor.component.scss'],
    standalone: false
})
export class RowEditorComponent implements OnInit {

    @Input() table: Table;
    @Input() data: any;
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {
      if (this.config && this.config.data) {
          if (this.config.data.table) {
            this.table = this.config.data.table;
            console.log(this.table);
          }
          if (this.config.data.data) {
              this.data = this.config.data.data;
              console.log(this.data);
          }
      }
  }

}
